// extracted by mini-css-extract-plugin
module.exports = {"main":"StorageOptimizationModal_main__hmrL5"};